import { useMemo } from 'react'
import { ARCHIVED_STATUSES, POST_TRANSIT_STATUSES } from 'apps/booking/constants/shipments'
import { IShipmentProgressQuery } from '../ShipmentProgress/graphql/ShipmentProgress'
import { IAppointmentsViewQuery } from '../ShipmentSchedulingTab/graphql/AppointmentsView'

type IShipment = IAppointmentsViewQuery['shipment'] | IShipmentProgressQuery['shipment']
const CANT_REARRANGE_STATUS = [...ARCHIVED_STATUSES, ...POST_TRANSIT_STATUSES]

interface IUseRearrangeShipmentStopsModalButtonProps {
  shipment?: IShipment
}

const canRearrangeStops = (shipment: IShipment): boolean => {
  const { stops = [], state } = shipment || {}
  const hasMoreThanTwoStops = stops.length > 2
  const hasNoCompletedStops = !stops.some(({ arrivedAt }) => Boolean(arrivedAt))
  const shipmentIsNotDelivered = state && !CANT_REARRANGE_STATUS.includes(state)
  return [hasMoreThanTwoStops, hasNoCompletedStops, shipmentIsNotDelivered].every(Boolean)
}

/**
 * Handles visibility state of 'Rearrange Stops' button
 */
export const useRearrangeShipmentStopsModalButton = ({
  shipment,
}: IUseRearrangeShipmentStopsModalButtonProps) => {
  const canRearrange = useMemo(() => canRearrangeStops(shipment), [shipment])

  return { isVisible: canRearrange }
}
